import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { addNotification } from '../../../actions/cc-mode';
import { setInviteCardOpen, setJoiningStatus } from '../../../actions/conversation';
import { setLoadingApp } from '../../../actions/session';
import SearchAvaRoomInput from './SearchAvaRoomInput';
const mapStateToProps = ({ scribeConversation: { joiningStatus }, scribeSession: { captioner }, scribeTranscriptUI: { electronCaptionMode }, }) => ({
    electronCaptionMode,
    joiningStatus,
    user: captioner,
});
const mapDispatchToProps = {
    addNotification,
    setInviteCardOpen,
    setJoiningStatus,
    setLoadingApp,
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SearchAvaRoomInput));
